/**
 * Javascript for Checkout page
 */
import Vue from 'vue';

import Checkout from '../vue/checkout/App.vue';
import BillingFields from '../vue/checkout/BillingFields.vue';
import ShippingFields from '../vue/checkout/ShippingFields.vue';
import ShippingMethods from '../vue/checkout/ShippingMethods.vue';
import Currency from '../vue/checkout/Currency.vue';

export default {
  init() {
    Vue.component('checkout-fields', Checkout);
    Vue.component('billing-fields', BillingFields);
    Vue.component('shipping-fields', ShippingFields);
    Vue.component('shipping-methods', ShippingMethods);
    Vue.component('currency', Currency);

    new Vue({
      el: '#checkout-fields',
    });

    $(document.body).on('stripeError', function(e, result) {
      const message = result.error.message;
      $('#stripe-error-wrapper')
        .html(message)
        .fadeIn();
      setTimeout(() => {
        $('#stripe-error-wrapper').fadeOut();
      }, 3000);
    });

    $(document.body).on('checkout_error', function() {
      const errors = $('.woocommerce-error li');
      errors.each(index => {
        const single = $(errors[index]);
        const name = single.attr('data-id');
        let input = $(`input[name="${name}"]`);
        if (name === 'password_not_match') {
          input = $('input[name="password"');
        }
        const message = single.html();
        input.after(
          `<p class="checkout-error-input text-xs text-red-500">${message}</p>`
        );
      });
      $('form.checkout').submit(() => {
        $('p.checkout-error-input').remove();
      });
    });

    $('[name="payment_method"]').on('change', () => {
      const selected = $('[name="payment_method"]:checked');
      $('.payment-method .radio-button')
        .removeClass('border-5 border-almostBlack')
        .addClass('border border-brandGray');
      $('.payment-fields').fadeOut();
      $('.payment-title')
        .removeClass('text-almostBlack')
        .addClass('text-brandGray');
      const wrapper = $(selected).closest('.payment-method');
      $(wrapper)
        .find('.radio-button')
        .removeClass('border border-brandGray')
        .addClass('border-5 border-almostBlack');
      $(wrapper)
        .parent()
        .find('.payment-fields')
        .fadeIn();
      $(wrapper)
        .find('.payment-title')
        .removeClass('text-brandGray')
        .addClass('text-almostBlack');
    });

    /**
     * Remove from cart
     */
    $('[wc-action="remove-from-cart"]').on('click', function() {
      const key = $(this).attr('data-cart-key');
      const shipping = $('[name="shipping_method[0]"]').val();
      const item = $(this).closest('.cart-single-item');
      $.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.ajax_url,
        data: {
          action: 'woocommerce_ajax_remove_from_cart',
          key,
          shipping,
        },
        success: function(response) {
          if (!response.error) {
            const total = parseFloat(response.total)
              .toFixed(0)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            $('#totalPrice').html(`${total} Kč`);
            $(item).remove();

            const fragments = response.fragments;

            if (fragments) {
              $.each(fragments, (key, value) => {
                $(key).replaceWith(value);
              });
            }
          }
        },
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerceCheckout.js